import React, { forwardRef } from 'react';
import Proptypes from 'prop-types';
import MaterialCircularProgress from '@material-ui/core/CircularProgress';
import clsx from 'clsx';
import { makeStyles } from '../../lib/styles';
import getThemeColor from '../../lib/getThemeColor';

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: theme.spacing(1),
    padding: theme.spacing(1),
    color: ({ color }) => getThemeColor(theme, color, 'main'),
  },
  icon: {
    width: 18,
    height: 18,
  },
  uncheckedIcon: {
    color: theme.palette.grey[300],
  },
}));

const CircularProgress = forwardRef(function CircularProgress(
  { className, color, disableShrink, size, thickness, value, variant, ...restProps },
  ref
) {
  const { root } = useStyles({ color });
  return (
    <MaterialCircularProgress
      className={clsx(className, root)}
      ref={ref}
      {...restProps}
      disableShrink={disableShrink}
      size={size}
      thickness={thickness}
      value={value}
      variant={variant}
    />
  );
});

CircularProgress.propTypes = {
  className: Proptypes.string,
  color: Proptypes.oneOf([
    'primary',
    'secondary',
    'default',
    'info',
    'success',
    'warning',
    'danger',
  ]),
  disableShrink: Proptypes.bool,
  size: Proptypes.string,
  thickness: Proptypes.number,
  value: Proptypes.number,
  variant: Proptypes.oneOf(['determinate', 'indeterminate', 'static']),
};

CircularProgress.defaultProps = {
  className: '',
  color: 'primary',
  disableShrink: false,
  size: '1rem',
  thickness: 3.6,
  value: 0,
  variant: 'indeterminate',
};

CircularProgress.displayName = 'CircularProgress';

export default CircularProgress;
